/* ============================================================================
   JuiceBox Bar wall — companion script for snippets/jb-juicebar-wall.liquid

   ES5 throughout (var / function, no arrow functions, no class), matching
   assets/jb-home-2026.js. No jQuery, no build step.

   Three jobs:
     1. Batch reveal   — button and IntersectionObserver share one code path
     2. Sticky CTA     — shown across the wall, retired at the closing CTA
     3. Lightbox       — native <dialog>, arrow keys and swipe walk the wall

   Companion files (keep in sync when editing):
     snippets/jb-juicebar-wall.liquid
     assets/jb-juicebar-wall.css
   ========================================================================= */
(function () {
  var root = document.querySelector('.jb-wall26');
  if (!root) return;

  var wall = root.querySelector('[data-jbw-wall]');
  if (!wall) return;

  var moreBtn = root.querySelector('[data-jbw-more]');
  var endNote = root.querySelector('[data-jbw-end]');

  // One record per tile, built once. The lightbox walks this list.
  var tiles = Array.prototype.slice.call(wall.querySelectorAll('[data-jbw-tile]'));
  var items = tiles.map(function (el) {
    var nameEl = el.querySelector('.jbw-tile__name');
    return { el: el, name: nameEl ? nameEl.textContent : '' };
  });

  // ---- Batch reveal -------------------------------------------------------
  var batches = Array.prototype.slice.call(wall.querySelectorAll('[data-jbw-batch]'));
  var io = null;

  function hiddenBatch() {
    for (var i = 0; i < batches.length; i++) {
      if (batches[i].hasAttribute('hidden')) return batches[i];
    }
    return null;
  }

  function finish() {
    if (moreBtn) moreBtn.hidden = true;
    if (endNote) endNote.hidden = false;
    if (io) { io.disconnect(); io = null; }
  }

  function reveal() {
    var next = hiddenBatch();
    if (!next) { finish(); return; }
    next.removeAttribute('hidden');
    next.classList.add('is-new');
    next.addEventListener('animationend', function () {
      next.classList.remove('is-new');
    }, { once: true });
    if (!hiddenBatch()) finish();
  }

  if (moreBtn) {
    moreBtn.addEventListener('click', reveal);
    // The button IS the observer target, so there is exactly one reveal path.
    // No IntersectionObserver -> the button still works. Reveal is finite, so
    // the footer never runs away from the visitor.
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].isIntersecting) reveal();
      }, { rootMargin: '900px 0px' });
      io.observe(moreBtn);
    }
  }

  // ---- Sticky CTA ---------------------------------------------------------
  // The page runs to ~25,000px once a few batches are open, so the closing CTA
  // is a very long way from anyone actually browsing photos.
  //
  // A throttled scroll listener rather than an IntersectionObserver, on
  // purpose. IO fires only when an element CROSSES the boundary, and the wall
  // is far taller than the viewport — once you are inside it nothing crosses,
  // so the callback never runs again. Keying off the short hero fixes that but
  // leaves a second failure mode: IO and requestAnimationFrame are both
  // suspended while a document is hidden, so a tab woken in the background
  // would come back showing the wrong state. Two rect reads are cheap and
  // correct in every one of those cases.
  var sticky = root.querySelector('[data-jbw-sticky]');
  var heroEl = root.querySelector('.jbw-hero');
  var ctaEl = root.querySelector('.jbw-cta');

  if (sticky && heroEl) {
    var queued = false;

    function syncSticky() {
      queued = false;
      // Show once the hero is fully behind you...
      var show = heroEl.getBoundingClientRect().bottom < 0;
      // ...and retire it as the real CTA arrives, so the two never compete.
      if (show && ctaEl) {
        show = ctaEl.getBoundingClientRect().top > window.innerHeight * 0.6;
      }
      sticky.classList.toggle('is-visible', show);
    }

    // setTimeout, not requestAnimationFrame: rAF is suspended while a document
    // is hidden, which would leave the throttle latched and the bar stuck.
    // This is a class toggle, not an animation — it need not land on a frame.
    function onScroll() {
      if (queued) return;
      queued = true;
      window.setTimeout(syncSticky, 100);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // Covers deep links, reloads mid-page, and bfcache restores.
    window.addEventListener('pageshow', syncSticky);
    syncSticky();
  }

  // ---- Lightbox -----------------------------------------------------------
  var dlg = root.querySelector('[data-jbw-lb]');
  var lbImg = root.querySelector('[data-jbw-lb-img]');
  var lbName = root.querySelector('[data-jbw-lb-name]');
  var stage = root.querySelector('[data-jbw-lb-stage]');
  var lbIdx = -1;
  // Without showModal there is no focus trap and no top layer, so fall back to
  // doing nothing rather than opening a half-working box.
  var CAN_MODAL = dlg && typeof dlg.showModal === 'function';

  function bigSrc(img) {
    return img.getAttribute('src').replace(/([?&])width=\d+/, '$1width=1400');
  }

  function lbShow(i) {
    if (!items.length) return;
    if (i < 0) i = items.length - 1;
    if (i >= items.length) i = 0;
    lbIdx = i;

    var rec = items[i];
    var img = rec.el.querySelector('img');
    if (!img) return;

    // The tile's already-cached small render, blurred up behind the large one.
    if (stage) stage.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
    lbImg.classList.remove('is-ready');
    lbImg.setAttribute('width', img.getAttribute('width'));
    lbImg.setAttribute('height', img.getAttribute('height'));
    lbImg.alt = 'JuiceBox Bar par ' + rec.name;
    lbImg.src = bigSrc(img);
    if (lbName) lbName.textContent = rec.name;
    if (lbImg.complete) lbImg.classList.add('is-ready');

    // Warm the neighbours so an arrow press is instant.
    [items[i - 1], items[i + 1]].forEach(function (n) {
      if (!n) return;
      var ni = n.el.querySelector('img');
      if (!ni) return;
      var pre = new Image();
      pre.src = bigSrc(ni);
    });
  }

  if (CAN_MODAL) {
    lbImg.addEventListener('load', function () { lbImg.classList.add('is-ready'); });

    // One delegated handler for every tile. Note NO tile carries aria-controls
    // — see the note in jb-juicebar-wall.css.
    wall.addEventListener('click', function (e) {
      var tile = e.target.closest ? e.target.closest('[data-jbw-tile]') : null;
      if (!tile) return;
      for (var k = 0; k < items.length; k++) {
        if (items[k].el === tile) { lbShow(k); dlg.showModal(); return; }
      }
    });

    dlg.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowRight') { e.preventDefault(); lbShow(lbIdx + 1); }
      else if (k === 'ArrowLeft') { e.preventDefault(); lbShow(lbIdx - 1); }
      // Escape is handled natively by <dialog>.
    });

    dlg.addEventListener('click', function (e) {
      // Backdrop or letterbox padding closes; the image itself does not.
      if (e.target === dlg || e.target === stage) dlg.close();
      var act = e.target.closest
        ? e.target.closest('[data-jbw-lb-close],[data-jbw-lb-prev],[data-jbw-lb-next]')
        : null;
      if (!act) return;
      if (act.hasAttribute('data-jbw-lb-close')) dlg.close();
      else if (act.hasAttribute('data-jbw-lb-prev')) lbShow(lbIdx - 1);
      else lbShow(lbIdx + 1);
    });

    // Focus returns to the tile the visitor ENDED on, not the one they opened
    // — matching every native photo viewer — and it must be scrolled into view.
    dlg.addEventListener('close', function () {
      var rec = items[lbIdx];
      if (!rec) return;
      rec.el.scrollIntoView({ block: 'center' });
      rec.el.focus();
    });

    // Swipe. Passive throughout: the stage never scrolls horizontally, so
    // there is nothing to preventDefault.
    if (stage) {
      var sx = 0, sy = 0;
      stage.addEventListener('touchstart', function (e) {
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          lbShow(lbIdx + (dx < 0 ? 1 : -1));
        } else if (dy > 90 && Math.abs(dy) > Math.abs(dx) * 1.4) {
          dlg.close();
        }
      }, { passive: true });
    }
  }

  // Batches 2..n ship with the hidden attribute already set in Liquid, so the
  // page is correct before this script runs and complete without it (see the
  // <noscript> block in the snippet). Nothing to initialise here.
})();
